import { Component, OnInit, inject } from '@angular/core';
import {Observable, zip} from 'rxjs';
import {Signaalkaart} from '../../../signaalkaart/signaalkaart';
import {Client} from '../../../client/client';
import {SignaalkaartAntwoord} from '../../../signaalkaart/signaalkaart-antwoord';
import {map, mergeMap} from 'rxjs/operators';
import {SignaalkaartService} from '../../../signaalkaart/signaalkaart.service';
import {SignaalkaartAntwoordService} from '../../../signaalkaart/signaalkaart-antwoord.service';
import {ActivatedRoute} from '@angular/router';
import {ClientService} from '../../../client/client.service';
import {Location} from '@angular/common';

@Component({
    templateUrl: './signaalkaart-antwoord.page.html',
    styleUrls: ['./signaalkaart-antwoord.page.scss'],
    standalone: false
})
export class SignaalkaartAntwoordPage implements OnInit {
  private signaalkaartService = inject(SignaalkaartService);
  private signaalkaartAntwoordService = inject(SignaalkaartAntwoordService);
  private clientService = inject(ClientService);
  private route = inject(ActivatedRoute);
  private location = inject(Location);

  signaalkaart$: Observable<Signaalkaart>;
  signaalkaartAntwoord$: Observable<SignaalkaartAntwoord>;
  client$: Observable<Client>;

  ngOnInit(): void {
    this.client$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.clientService.getClientById$(id)),
      );
    this.signaalkaartAntwoord$ = this.route.paramMap.pipe(
      map(paramMap => paramMap.get('signaalkaartAntwoordId')),
      mergeMap(id => this.signaalkaartAntwoordService.getSignaalkaartById(id))
    );
    this.signaalkaart$ = zip(
      this.signaalkaartAntwoord$,
      this.signaalkaartService.getSignaalkaarten$(),
    ).pipe(map(([antwoord, signaalkaarten]) => signaalkaarten.getSignaalkaartWithIdAndVersie(antwoord.getSignaalkaartId(), antwoord.getSignaalkaartVersie())));
  }

  navigateBack(): void {
    this.location.back();
  }
}
